//Post save
document.addEventListener("DOMContentLoaded", () => {
  setCommentActionsEvents();

  document.addEventListener("click", function (event) {
    var element = event.target.closest(".post-reactions");
    if (!element) return;
  
    var url = element.dataset.linkReactions;
    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");
  
    fetch(url, {
      method: "GET",
      headers: {
        "X-CSRF-Token": csrfToken,
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "text/javascript",
      },
    })
      .then((response) => response.text())
      .then((data) => {
        eval(data);
      })
      .catch((error) => console.error("Error fetching reactions:", error));
  });
});


function setCommentActionsEvents() {
  let savePostLinks = document.querySelectorAll(".savePostLink");
  let unsavePostLinks = document.querySelectorAll(".unsavePostLink");
  let savePostModal = document.getElementById("savePostModal");
  let unsavePostModal = document.getElementById("unsavePostModal");
  let savePostConfirmBtn = document.getElementById("savePostConfirmBtn");
  let savePostCancelBtn = document.getElementById("savePostCancelBtn");
  let unsavePostConfirmBtn = document.getElementById("unsavePostConfirmBtn");
  let unsavePostCancelBtn = document.getElementById("unsavePostCancelBtn");
  let postId = null;

  // Helper functions
  let showModal = (modal) => modal?.classList.remove("hidden");
  let hideModal = (modal) => modal?.classList.add("hidden");

  let updateLink = (action, postId) => {
    let saveLink = document.querySelector(`#post-save-${postId} .savePostLink`);
    let unsaveLink = document.querySelector(`#post-save-${postId} .unsavePostLink`);
    if (action === "saved") {
      saveLink.classList.add("hidden");
      saveLink.classList.remove("block");
      unsaveLink.classList.remove("hidden");
      unsaveLink.classList.add("block");
    } else if (action === "save") {
      saveLink.classList.remove("hidden");
      saveLink.classList.add("block");
      unsaveLink.classList.add("hidden");
      unsaveLink.classList.remove("block");
    }

    // Close the dropdown
    let dropdown = this.closest(".popupMenumoreDetailsdrop");
    if (dropdown) {
      dropdown.classList.add("hidden");
    }
  };

  // Save Post
  savePostCancelBtn?.addEventListener("click", () => hideModal(savePostModal));
  savePostConfirmBtn?.addEventListener("click", () => {
    fetch("/follow_post", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ post_id: postId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          hideModal(savePostModal);
          updateLink("saved", postId);
          let flashMessage = document.createElement("div");
          flashMessage.innerText = I18n.t("post_saved");
          flashMessage.classList.add("fixed", "flex", "bg-secondary-light", "dark:bg-white", "items-center", "w-max", "max-w-[95vw]", "p-4", "space-x-4", "text-primary-text-dark", "divide-x", "rtl:divide-x-reverse", "divide-gray-200", "rounded-lg", "shadow", "md:top-[70px]", "bottom-10", "right-5", "md:bottom-auto", "md:left-auto", "dark:text-primary-text-light", "dark:divide-gray-700", "space-x", "dark:bg-gray-800", "z-40", "slide-in");
          document.body.appendChild(flashMessage);
          setTimeout(() => document.body.removeChild(flashMessage), 3000);
        }
      })
      .catch((error) => console.error("Error:", error));
  });

  // Unsave Post
  unsavePostCancelBtn?.addEventListener("click", () => hideModal(unsavePostModal));
  unsavePostConfirmBtn?.addEventListener("click", () => {
    fetch("/unfollow_post", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ post_id: postId }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          hideModal(unsavePostModal);
          updateLink("save", postId);
          let flashMessage = document.createElement("div");
          flashMessage.innerText = I18n.t("unsaved_post");
          flashMessage.classList.add("fixed", "flex", "bg-secondary-light", "dark:bg-white", "items-center", "w-max", "max-w-[95vw]", "p-4", "space-x-4", "text-primary-text-dark", "divide-x", "rtl:divide-x-reverse", "divide-gray-200", "rounded-lg", "shadow", "md:top-[70px]", "bottom-10", "right-5", "md:bottom-auto", "md:left-auto", "dark:text-primary-text-light", "dark:divide-gray-700", "space-x", "dark:bg-gray-800", "z-40", "slide-in");
          document.body.appendChild(flashMessage);
          setTimeout(() => document.body.removeChild(flashMessage), 3000);
        }
      })
      .catch((error) => console.error("Error:", error));
  });

  // Set Save/Unsave Event Listeners
  let setSaveComment = () => {
    savePostLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        postId = link.dataset.postId;
        showModal(savePostModal);
      });
    });

    unsavePostLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        postId = link.dataset.postId;
        showModal(unsavePostModal);
      });
    });
  };

  setSaveComment();

  // Copy Link
  let copyLinks = document.querySelectorAll(".copy-link");
  copyLinks.forEach((link) => {
    link.addEventListener("click", function () {
      let origin = window.location.origin;
      let element = document.getElementById(`copy_to_clipboard_${this.dataset.postId}`);
      let linkStr = element ? `${origin}${element.dataset.link || ''}` : '';
      copyText(linkStr);

      // Close the dropdown
      let dropdown = this.closest(".popupMenumoreDetailsdrop");
      if (dropdown) {
        dropdown.classList.add("hidden");
      }
      let footer_copied = this.closest(".comment-footer").querySelector(`#link-copied-${this.dataset.postId}`);
      footer_copied.style.display = "block";
      footer_copied.focus();
      setTimeout(() => {
        fadeOut(footer_copied);
      }, 2000);
    });
  });

  function copyText(text) {
    if (!document.hasFocus()) {
      return;
    }
    window.navigator.clipboard
      .writeText(text)
      .then(() => {})
      .catch((err) => {
        console.error("Unable to copy text: ", err);
      });
  }

  // Reactions
  var currentUserIdElement = document.getElementById("CurrentUserID");
  if (currentUserIdElement != null) {
    var postReactedElement = document.getElementById("PostReacted");
    if (postReactedElement != null) {
        var reactionsGiven = JSON.parse(postReactedElement.getAttribute('data-reactions-given'));
        reactionsGiven.forEach((reaction) => {
            if (document.querySelector(".voting_status_" + reaction.post_id)) {
              document.querySelector(".voting_status_" + reaction.post_id).innerHTML = `
                <img alt="${reaction.name}" loading="lazy" src="${reaction.reaction_url}" height="20" width="20">
                <span class="text-secondary-text-light dark:text-secondary-text-dark ml-2 md:text-sm text-xs gtm-post-like">${reaction.name}</span>
              `;
            }

            document.querySelector(`.reactions_${reaction.post_id}`)?.remove();
            
        });
    }
  }
}

// Helper functions for like button behavior
function closeMobileReactions() {
  document.querySelectorAll('.reactions[data-mobile-opened="true"]').forEach(div => {
    div.style.maxWidth = '0px';
    div.classList.remove('active');
    setTimeout(() => {
      div.innerHTML = '';
      div.dataset.loaded = false;
      div.dataset.mobileOpened = '';
      div.classList.add('!hidden');
    }, 100);
  });
}

function showMobileReactions(postId, container) {
  // Reuse existing hover logic from reactions.js
  if (window.showReactionsPopup) {
    window.showReactionsPopup(container, postId);
    const reactionsDiv = document.querySelector(`.reactions_${postId}`);
    if (reactionsDiv) {
      reactionsDiv.dataset.mobileOpened = 'true';
    }
  }
}

function upvotePost(postId, reactionId) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
  if (!csrfToken) return;

  fetch(`/posts/voteup?id=${postId}&reaction_id=${reactionId}`, {
    method: "PUT",
    headers: {
      "X-CSRF-Token": csrfToken,
      "X-Requested-With": "XMLHttpRequest",
      "Accept": "text/javascript",
    },
  })
    .then((response) => response.text())
    .then((data) => eval(data))
    .catch((error) => console.error("Error upvoting:", error));
}

// Like button click handler - desktop vs mobile behavior
document.addEventListener('click', function(event) {
  const isMobile = window.innerWidth < 768;
  
  // Close mobile-opened containers when clicking outside
  if (isMobile && !event.target.closest('.reactions, .reaction-list, .reaction-icon')) {
    closeMobileReactions();
  }

  const reactionList = event.target.closest('.reaction-list');
  if (!reactionList) return;

  const reactionPopup = reactionList.closest('.reaction-popup');
  if (!reactionPopup) return;

  event.preventDefault();
  event.stopPropagation();

  const postId = reactionPopup.dataset.id;

  if (isMobile) {
    const container = reactionPopup.closest('.reactions-container');
    if (container) showMobileReactions(postId, container);
  } else {
    const reactions = window.appconfig?.reactions;
    const likeReaction = reactions?.find(r => r.id === 1) || reactions?.[0];
    if (likeReaction) upvotePost(postId, likeReaction.id);
  }
});

window.setCommentActionsEvents = setCommentActionsEvents;
